
import { Component, Vue, Prop } from 'vue-property-decorator'
import DonationFormSection from './commons/DonationFormSection.vue'
import { IProjectDetailSettings } from '@/types/cms'
import { IPaymentProvider } from '@/types/finances'
import { API_URLS } from '@/utils/helpers'
import axios from 'axios'
@Component({
  components: {
    DonationFormSection
  }
})
export default class SelectPaymentProvider extends Vue {
  @Prop() projectDetailSettings!: IProjectDetailSettings
  @Prop() orgaColor!: string

  paymentProviders: IPaymentProvider[] = []

  donate(paymentProvider: IPaymentProvider) {
    this.$emit('donate', paymentProvider)
  }

  donateWithManualBankTransfer () {
    this.$emit('donateWithManualBankTransfer')
  }

  async mounted (): Promise<void> {
    await axios.get(API_URLS.EXPLORE.PAYMENT_PROVIDERS).then(response => {
      this.paymentProviders = response.data.results
    })
  }
}
